module.exports = __webpack_public_path__ + "static/img/Skateboard-1.e2143127.png";